import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails, ICarrierBranchResponseDTO } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetBranchesPaginatedCommand extends IRequestCommand<
  IGetBranchesPaginatedResponse,
  ErrorDetails,
  IGetBranchesPaginatedCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/branches/paginated?';

  public override setParameters(parameters: IGetBranchesPaginatedCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.concat(`page=${parameters.page ?? 1}`);
    this._commandUrl = this._commandUrl.concat(
      parameters.size != null ? `&size=${parameters.size}` : '&size=10'
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.column ? `&column=${parameters.column}` : '&column=id'
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.sort ? `&sort=${parameters.sort}` : '&sort=ASC'
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.find != null ? `&find=${parameters.find}` : '&find='
    );
  }
}

export interface IGetBranchesPaginatedCommandParameters extends ICommandParameters {
  carrierId: number;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  find?: string;
}

export interface IGetBranchesPaginatedResponse extends ICommandResponse {
  content: (ICarrierBranchResponseDTO & { affiliateBranch?: boolean })[];
  totalPages: number;
  totalElements: number;
  pageable: {
    pageNumber: number;
    pageSize: number;
  };
}
